import { truncateText } from "../../utils/textTruncateUtils";


const FileCard = ({ icon, name, user, modified, size, actions, onClick }) => (
    <div
        className="card doc-store-list-view-bg file-card"
        style={{ cursor: onClick ? "pointer" : "default", width: "130px", height: "105px",transition: "box-shadow 0.3s ease" }}
        onDoubleClick={onClick}
    >
        <div className="d-flex flex-column align-items-center justify-content-center h-100">
            <div className="py-2">{icon}</div>
        </div>
        <div className="grid-view-border-top w-100 d-flex justify-content-between align-items-center px-1">
            <div className="fnt14 ps-1 py-1 mb-0" title={name}>
                {truncateText(name, 9)}
            </div>
            <div className="" style={{ marginRight: "-6px" }}>{actions}</div>
        </div>
    </div >
);

export default FileCard;
